import { HashLocationStrategy } from "@angular/common";
import { Injectable } from "@angular/core";

@Injectable()
export class ParameterHashLocationStrategy extends HashLocationStrategy {
  prepareExternalUrl(internal: string): string {
    return window.location.search + super.prepareExternalUrl(internal);
  }
}
